import React, { useEffect, useState } from "react";
import Portfoliopageheading from "./Portfoliopageheading";
import Bgimage from "../HomePage/Bgimagesection/Bgimage";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import ScrollToTopButton from "../HomePage/Scrolltotop/ScrollToTopButton";
import FloatingContactButton from "../../components/ContactUs/FloatingContactButton";
import FloatingWhatsappButton from "../../components/ContactUs/FloatingWhatsappButton";
import { Helmet } from "react-helmet-async";
import CategoryTab from "./CategoryTab";
import PortfolioGrid from "./PortfolioGrid";
import { portfolioitems } from "./portfolioitems";
import './Portfoliopage.css';

function Portfoliopage() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [activeSubCategory, setActiveSubCategory] = useState("All");

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the window to the top when the component mounts
  }, []);

  useEffect(() => {
    const images = document.querySelectorAll('.fade-in');
    images.forEach(image => {
      // If it's already loaded
      if (image.complete) {
        image.classList.add('loaded');
      } else {
        image.onload = () => {
          image.classList.add('loaded');
        };
      }
    });
  }, [activeCategory, activeSubCategory]);

  const filteredItems = portfolioitems.filter(item => {
    if (activeCategory === "All") return true;

    const itemCategories = Array.isArray(item.category) ? item.category : [item.category];
    if (!itemCategories.includes(activeCategory)) return false;

    if (activeCategory === "Web Application" && activeSubCategory !== "All") {
      const itemSubCategories = Array.isArray(item.subCategory) ? item.subCategory : [item.subCategory];
      return itemSubCategories.includes(activeSubCategory);
    }

    return true;
  });

  return (
    <div style={{ background: "#181818" }}>
      <Helmet>
        <title>Our Portfolio | Custom Web & Mobile App Case Studies - Dwebbox</title>
        <meta
          name="description"
          content="Explore Dwebbox's portfolio of successful digital products. See our work in MERN stack web apps, React Native mobile apps, and AI solutions across various industries."
        />
        <meta name="keywords" content="software development portfolio, web app case studies, mobile app examples, UI/UX design showcase, Dwebbox projects" />
        <link rel="canonical" href="https://dwebbox.com/portfolio" />

        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://dwebbox.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Portfolio",
                "item": "https://dwebbox.com/portfolio"
              }
            ]
          })}
        </script>
      </Helmet>
      <ScrollToTopButton />
      <FloatingContactButton />
      <FloatingWhatsappButton />
      <Navbar />
      <Portfoliopageheading />

      <CategoryTab
        activeCategory={activeCategory}
        setActiveCategory={setActiveCategory}
        activeSubCategory={activeSubCategory}
        setActiveSubCategory={setActiveSubCategory}
      />

      <PortfolioGrid
        activeCategory={activeCategory}
        activeSubCategory={activeSubCategory}
        filteredItems={filteredItems}
      />

      <Bgimage />
      <Footer />
    </div>
  );
}

export default Portfoliopage;

